import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const IntegrationLog = React.lazy(() =>
    import('../IntegrationLog')
);
const integrationLogRoutesRegistry = [
    {
        path: PAGE_URL.INTEGRATION_LOG_PAGE,
        element: <IntegrationLog />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default integrationLogRoutesRegistry;
